<template>
  <div class="market-login-form market-login-form--user">
    <el-form
      ref="logoForm"
      :model="logoForm"
      :rules="rules"
      class="market-login-form__form"
      @submit.native.prevent
    >
      <el-form-item
        prop="username"
        :error="errorUserMsg"
        class="market-login-form__field"
      >
        <el-input
          v-model="logoForm.username"
          placeholder="请输入账号、企业邮箱或手机号"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        prop="password"
        :error="errorUserMsg"
        class="market-login-form__field"
      >
        <el-input
          v-model="logoForm.password"
          type="password"
          placeholder="请输入密码"
          @keyup.enter.native="submitForm('logoForm')"
        ></el-input>
      </el-form-item>

      <el-form-item prop="captcha_code" class="market-login-form__field">
        <div class="market-login-form__captcha-row">
          <el-input
            v-model="logoForm.captcha_code"
            type="text"
            placeholder="请输入验证码"
            clearable
          ></el-input>
          <img
            class="market-login-form__captcha-image"
            :src="imgsrc"
            @click="handleImgSrc"
          />
        </div>
      </el-form-item>

      <div class="market-login-form__secondary">
        <a @click="handleForgetPassword">找回密码</a>
        <span>没有账号？<a @click="register">去注册</a></span>
      </div>

      <el-form-item class="market-login-form__submit-wrap">
        <el-button
          type="primary"
          class="market-login-form__submit"
          :loading="loading"
          v-on:click="submitForm('logoForm')"
          >登 录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addAccessKeyApi } from '@/api/enterpriseManage';
import DialogVerificationCode from '@/components/Dialog/VerificationCode/index.vue';
import { validateEmpty, validateRedirect } from '@/utils/validate';
import Base64 from 'base-64';
import { errorHandle } from '../../../../utils/error';
export default {
  name: 'Signin',
  data() {
    const validateMobileEname = (rule, value, callback) => {
      if (!validateEmpty(value)) {
        callback(new Error('请输入账号或手机号码或邮箱'));
      }
      callback();
    };
    // 校验手机号
    const validatePhone = (_, value, callback) => {
      if (!value) {
        callback(new Error('手机号码不能为空'));
      }
      // 校验手机号码的正则
      const reg =
        /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      const result = reg.test(value);
      if (!result) {
        callback(new Error('请输入合法的手机号码'));
      } else {
        callback();
      }
    };
    return {
      content: '获取验证码',
      // 发送验证码按钮的节流
      disabled: false,
      // 验证码弹窗的显示与隐藏
      dialogVisible: false,
      // 倒计时
      totalTime: 60,
      // 定时器ID
      timer: null,
      loading: false,
      errorUserMsg: null,
      certification: window.location.href.indexOf('certification') > -1,
      redirect: '/manage/overview',
      logoForm: {
        username: '',
        password: '',
        phone: '',
        phoneCode: '',
        captcha_code: '',
        captcha_id: ''
      },
      rules: {
        username: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobileEname
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          { min: 6, message: '密码长度最小6位', trigger: 'blur' },
          { max: 255, message: '密码长度最大255位', trigger: 'blur' }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePhone
          }
        ],
        phoneCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '请输入正确验证码',
            trigger: 'blur'
          }
        ],
        captcha_code: [
          { required: true, trigger: 'blur', message: '请输入验证码' },
          { min: 4, max: 4, message: '请输入4位验证码' }
        ]
      },
      // 图片验证码路径
      imgsrc: ''
    };
  },
  components: {
    DialogVerificationCode
  },
  created() {
    this.$store.commit('SET_RESET');
    // 判断当路由头中的redirect有且不为空的时候，将路由中的redirect信息给redirect
    if (this.$route.query.redirect && this.$route.query.redirect != '') {
      this.redirect = this.$route.query.redirect;
    }
    this.$store.dispatch('FedLogOut').then(() => {});
  },
  mounted() {
    if (this.$route.query && this.$route.query !== {}) {
      localStorage.setItem('rainbondInfo', JSON.stringify(this.$route.query));
    }
    this.handleImgSrc();
  },
  methods: {
    register() {
      this.$router.push({
        name: 'register'
      });
    },
    // 图片验证码路径
    handleImgSrc() {
      this.$store
        .dispatch('Verification')
        .then((res) => {
          if (res) {
            this.logoForm.captcha_id = res.id;
            this.imgsrc = res.data;
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    // 发送验证码
    handleSendCode(value) {
      this.$refs.logoForm.validateField(value, (valid) => {
        if (!valid) {
          if (this.disabled) return;
          this.dialogVisible = true;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 倒计时
    countDown() {
      this.disabled = true;
      this.dialogVisible = false;
      this.content = this.totalTime + 's';
      this.timer = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + 's';
        if (this.totalTime < 0) {
          this.totalTime = 60;
          this.content = '获取验证码';
          this.disabled = false;
          window.clearInterval(this.timer);
        }
      }, 1000);
    },
    handleForgetPassword() {
      this.$router.push({
        name: this.certification
          ? 'certificationForgetPassword'
          : 'forgetPassword'
        // query: { redirect: this.$route.fullPath }
      });
    },
    submitForm(formName) {
      this.errorUserMsg = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const rainbondInfo =
            JSON.parse(localStorage.getItem('rainbondInfo')) || {};
          var reg = /^\d{11}$/;
          if (!this.certification) {
            const sendForm = Object.assign({}, this.logoForm);
            if (sendForm.username.indexOf('@') == -1) {
              if (
                JSON.parse(window.sessionStorage.getItem('storeDomain')) &&
                !reg.test(sendForm.username)
              ) {
                sendForm.username = `${sendForm.username}@${JSON.parse(
                  window.sessionStorage.getItem('storeDomain')
                )}`;
              } else if (reg.test(sendForm.username)) {
                sendForm.username = sendForm.username.replace(/\s+/g, '');
              } else {
                sendForm.username = `${sendForm.username}@rainbond`;
              }
            } else {
              sendForm.username = sendForm.username.replace(/\s+/g, '');
            }
            sendForm.password = Base64.encode(sendForm.password);
            this.$store
              .dispatch('Login', sendForm)
              .then((res) => {
                if (res) {
                  this.$store
                    .dispatch('GetUserInfo')
                    .then((res) => {
                      if (res && res.roles) {
                        // window.sessionStorage.setItem("isAdmin",!(res.roles.indexOf("普通用户") != -1))
                        if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
                          window.sessionStorage.setItem('isAdmin', true);
                        } else {
                          if (res.roles.indexOf('普通用户') != -1) {
                            window.sessionStorage.setItem('isAdmin', false);
                          } else if (res.roles.indexOf('分享用户角色') != -1) {
                            window.sessionStorage.setItem('isAdmin', false);
                          } else {
                            window.sessionStorage.setItem('isAdmin', true);
                          }
                        }
                      }
                    })
                    .catch((re) => {});
                  if (res.token && this.certification) {
                    this.fetchAccessKeyApi();
                  } else {
                    this.loading = false;
                    if (window.sessionStorage.getItem('path')) {
                      window.location = window.sessionStorage.getItem('path');
                    } else {
                      if (
                        JSON.parse(window.sessionStorage.getItem('storeDomain'))
                      ) {
                        window.location = validateRedirect(
                          `/marketplace`
                        );
                      } else {
                        this.$store
                          .dispatch('GetUserInfo')
                          .then((res) => {
                            if (res && res.roles) {
                              window.sessionStorage.setItem('isAdmin', !(res.roles.indexOf('普通用户') != -1));
                              if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
                                window.location = validateRedirect('/manage/overview');
                              } else {
                                if (res.roles.indexOf('普通用户') != -1) {
                                  window.location = validateRedirect('/manage/general');
                                } else if (res.roles.indexOf('分享用户角色') != -1) {
                                  window.location = validateRedirect('/manage/general');
                                } else {
                                  const isAdmin = window.sessionStorage.getItem('isAdmin') != 'false';
                                  if (isAdmin) {
                                    window.location = validateRedirect(`/manage/overview`);
                                  } else {
                                    window.location = validateRedirect(`marketplace`);
                                  }
                                }
                              }
                            }
                          })
                          .catch((re) => {});
                      }
                    }
                    window.sessionStorage.removeItem('path');
                  }
                }
              })
              .catch((err) => {
                this.loading = false;
                this.handleImgSrc();
                errorHandle(err);
              });
          } else {
            // 表单校验
            this.$refs.logoForm.validate((vaild, values) => {
              if (!vaild) {
                return;
              }
              this.loading = true;
              this.$store
                .dispatch({
                  type: 'rainbondLogin',
                  payload: {
                    phone: this.logoForm.phone,
                    phoneCode: this.logoForm.phoneCode,
                    entName: rainbondInfo.enterprise_alias || '',
                    eid: rainbondInfo.enterprise_id || '',
                    realName: rainbondInfo.real_name || ''
                  }
                })
                .then((res) => {
                  if (res) {
                    if (res.token && this.certification) {
                      // 清空本地存储
                      localStorage.removeItem('rainbondInfo');
                      this.fetchAccessKeyApi();
                    } else {
                      this.loading = false;
                      window.location = validateRedirect(this.redirect);
                    }
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  errorHandle(err);
                });
            });
          }
        } else {
          return false;
        }
      });
    },
    getParentUrl() {
      var url = null;
      if (parent !== window) {
        try {
          url = parent.location.href;
        } catch (e) {
          url = document.referrer;
        }
      }
      return url;
    },
    fetchAccessKeyApi() {
      this.$store
        .dispatch('GetUserInfo')
        .then((res) => {
          if (res && res.eid) {
            addAccessKeyApi({
              eid: res.eid,
              note: `用于Rainbond平台从本市场安装应用(${this.getParentUrl()})`,
              actions: ['ReadInstall', 'OnlyRead', 'Write']
            })
              .then((res) => {
                window.parent.postMessage(
                  {
                    accessKey: res.accessKey
                  },
                  '*'
                );
                this.FedLogOut();
              })
              .catch((err) => {
                this.FedLogOut();
                errorHandle(err);
              });
          }
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    FedLogOut() {
      this.loading = false;
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.push({
          name: 'certificationLogin'
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import 'src/styles/login-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/login/components/UserLogin/index.vue